import { combineReducers } from 'redux';

import codeUpdate from './codeUpdate';
import create from './create';
import deactivate from './deactivate';
import prepare from './prepare';
import reactivate from './reactivate';
import unprepare from './unprepare';
import verify from './verify';

export default combineReducers({
  create,
  verify,
  prepare,
  unprepare,
  reactivate,
  deactivate,
  codeUpdate,
});
